import { render, staticRenderFns } from "./PreviewEmail.vue?vue&type=template&id=fa1bc256"
import script from "./PreviewEmail.vue?vue&type=script&lang=js"
export * from "./PreviewEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa1bc256')) {
      api.createRecord('fa1bc256', component.options)
    } else {
      api.reload('fa1bc256', component.options)
    }
    module.hot.accept("./PreviewEmail.vue?vue&type=template&id=fa1bc256", function () {
      api.rerender('fa1bc256', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/clients/components/PreviewEmail.vue"
export default component.exports